import store from "../../../store";
import { useRoute } from "vue-router";
import i18n from "../../../i18n";
import { notification } from "ant-design-vue";
import { createLoading } from "../../../utils/loading";

export const { isLoading, setIsLoading } = createLoading();

export const getActivateEmailByToken = ({ key }) => store.dispatch(`resource/v1/transaction/userRequest/getActivateEmailByToken`, { key });

export const initData = ({ data }) => {
    const route = useRoute();
    const keyToken = route.query?.key;
    data.form = createForm({ data });
    setIsLoading(true);
    getActivateEmailByToken({ key: keyToken })
        .then(() => {
            notification["success"]({ message: i18n.global.t("model.register.emailSuccess") });
            data.form.title = i18n.global.t("model.register.emailSuccess");
            data.form.src = require(`../../../assets/icon/checked.svg`);
        })
        .catch(() => {
            data.form.title = i18n.global.t("model.register.emailError");
            data.form.src = require(`../../../assets/icon/error_red_icon.svg`);
        })
        .finally(() => setIsLoading(false));
};

export const createForm = () => {
    return {
        title: null,
        src: null,
    };
};
